import Section from '@pelckmans/elementis/components/section';
import { useContext } from 'react';
import TableOfContentsContext from '../_contexts/TableOfContentsContext';
import { useTranslation } from 'react-i18next';

export default function ExerciseInstructionSection() {
  const { t } = useTranslation();
  const { selectedNode } = useContext(TableOfContentsContext);

  if (!selectedNode?.instructions) return null;

  return (
    <div className="exercise-instruction">
      <Section title={t('PAGES.VEM.INSTRUCTION.TITLE')} className="instruction">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: selectedNode.instructions }} />
      </Section>
    </div>
  );
}
